



/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// ADDSTATEPOST
// ADDSTATEPOST
const ADDSTATEPOST= createAsyncThunk(
  "AddStatePost/AddStatePost",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const AddStatePostSlice = createSlice({
  name: "AddStatePostSlice",
  initialState: {
    AddStatePost: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfAddStatePost: (state) => {
        state.AddStatePost.loading = false
        state.AddStatePost.error = false
        state.AddStatePost.data = []
        state.AddStatePost.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(ADDSTATEPOST.fulfilled, (state, action) => {
      state.AddStatePost = {
        ...state.AddStatePost,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(ADDSTATEPOST.pending, (state, action) => {
      state.AddStatePost = {
        ...state.AddStatePost,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(ADDSTATEPOST.rejected, (state, action) => {
      state.AddStatePost = {
        ...state.AddStatePost,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const AddStatePostAction = {
    ADDSTATEPOST,
};

export { AddStatePostAction };
export default AddStatePostSlice.reducer;
export const {setInitialStateOfAddStatePost} = AddStatePostSlice.actions